// Trail colours: each card type has a default colour that the user can
// change per card; links default to the colour of the card they come from.
import { Popover, Tooltip } from "antd";
import { Palette } from "lucide-react";

export const CARD_COLORS = [
  { name: "Blue", value: "#2563eb" },
  { name: "Violet", value: "#7c3aed" },
  { name: "Teal", value: "#0f766e" },
  { name: "Green", value: "#16a34a" },
  { name: "Amber", value: "#d97706" },
  { name: "Orange", value: "#ea580c" },
  { name: "Red", value: "#dc2626" },
  { name: "Pink", value: "#db2777" },
  { name: "Slate", value: "#475569" },
];

export const DEFAULT_COLORS = { source: "#2563eb", steps: "#7c3aed", outputFile: "#0f766e" };

// Light background for badges and labels: the colour at ~10% opacity.
export const tint = (color) => `${color}1a`;

const Swatches = ({ value, defaultLabel, defaultColor, onChange }) => (
  <div className="w-44 space-y-2">
    <div className="grid grid-cols-5 gap-1.5">
      {CARD_COLORS.map((color) => (
        <Tooltip key={color.value} title={color.name}>
          <button
            type="button"
            aria-label={color.name}
            onClick={() => onChange(color.value)}
            className={`h-6 w-6 rounded-full border-2 ${value === color.value ? "border-gray-900" : "border-white"} shadow-sm`}
            style={{ background: color.value }}
          />
        </Tooltip>
      ))}
    </div>
    <button
      type="button"
      onClick={() => onChange(undefined)}
      className={`flex w-full items-center gap-2 rounded px-1 py-0.5 text-left text-xs hover:bg-gray-50 ${value ? "text-gray-600" : "font-semibold text-gray-900"}`}
    >
      <span className="h-3 w-3 rounded-full" style={{ background: defaultColor }} />
      {defaultLabel}
    </button>
  </div>
);

// Palette button that opens the swatches. `value` is the custom colour, or
// undefined when the default is used.
export const ColorPicker = ({ value, defaultColor, defaultLabel = "Default", title = "Colour", onChange, className = "" }) => (
  // Stops clicks (also inside the popup) from selecting the card underneath.
  <span className={`nodrag nopan ${className}`} onClick={(event) => event.stopPropagation()}>
    <Popover
      trigger="click"
      title={title}
      content={<Swatches value={value} defaultColor={defaultColor} defaultLabel={defaultLabel} onChange={onChange} />}
    >
      <button type="button" aria-label={title} className="flex rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700">
        <Palette size={13} />
      </button>
    </Popover>
  </span>
);
